var route = {
  path : APP_CONFIG.oauthUrl ? APP_CONFIG.oauthUrl : `/OAuth/default`,
  getComponent(nextState, cb) {
      require.ensure([], (require) => {
          cb(null, require('../pc/components/ThirdPartyOAuth/OAuth.jsx').default)
      }, 'OAuth-ThirdParty')
  }
}

export default route;



// WEBPACK FOOTER //
// ./src/routes/OAuthUniversal.js